import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'

/*
	// to get a schema, run this as a graphql query in craft explorer
	{
	  __schema {
	    types {
	      kind
	      name
	      possibleTypes {
	        name
	      }
	    }
	  }
	}
*/

export default new IntrospectionFragmentMatcher({
	introspectionQueryResultData: {
		"__schema": {
			"types": [
				{
					"kind": "UNION",
					"name": "blogArticle_MatrixField",
					"possibleTypes": [
						{
							"name": "text_Entry"
						},
						{
							"name": "quote_Entry"
						},
						{
							"name": "image_Entry"
						},
						{
							"name": "video_Entry"
						}
					]
				}
			]
		}
	}
})



// WEBPACK FOOTER //
// ./src/components/CraftQL/fragmentMatcher.js